export default __webpack_public_path__ + "static/media/icon-cross-grey.485ee08a.svg";